@if (routeParts.length > 0) {
  <div class="container-breadcrumb">
    <section class="breadcrumb-title page-title ">
      @if (routeParts[routeParts.length - 1].backToPrevious) {
        <a href="javascript:void(0)"
          (click)="onBackClick()">
          <svg _ngcontent-own-c753="" id="Layer_1" version="1.1" viewBox="0 0 48 48" width="34px" height="34px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g _ngcontent-own-c753=""><path _ngcontent-own-c753="" fill="#0080bb" d="M24,46C11.9,46,2,36.1,2,24S11.9,2,24,2s22,9.9,22,22S36.1,46,24,46z M24,4C13,4,4,13,4,24c0,11,9,20,20,20   c11,0,20-9,20-20C44,13,35,4,24,4z"></path></g><g _ngcontent-own-c753=""><path _ngcontent-own-c753="" fill="#0080bb" d="m16.103895,23.56161c0,0.004858 0,0.009715 0,0.014573c0.002491,0.27203 0.119567,0.534344 0.323828,0.723794l10.384926,10.118538c0.406031,0.395901 1.063652,0.395901 1.469682,0s0.406031,-1.039543 0,-1.433014l-9.667522,-9.42389l9.667522,-9.433605c0.406031,-0.395901 0.406031,-1.037114 0,-1.435443c-0.406031,-0.395901 -1.066143,-0.395901 -1.469682,0l-10.404854,10.152541c-0.194297,0.189449 -0.3039,0.449335 -0.3039,0.716507z"></path></g>
        </svg>
      </a>
    }
    <span>
      {{ pageTitle }}
    </span>
  </section>
</div>
}
